import { NavigationList } from "@/features/navigation/components/navigation-list";
import { pageTitle } from "@/utils/page-title";
import { useTranslation } from "react-i18next";

export function SettingsPage() {
  const { t } = useTranslation();

  return (
    <div className="col-span-12 md:col-span-9">
      <title>{pageTitle(t("meta.settings"))}</title>
      <NavigationList />
    </div>
  );
}
